module.exports = __webpack_public_path__ + "img/pdf_letter_demo.ba899c16.png";